module.exports = __webpack_public_path__ + "static/bg-bd72f8b64a18b13f9d17e910d62e33fe.svg";